import { css } from 'styled-components';
import { StyledSecondaryIconButton } from '../Button/Iconbutton';
import { COLORS } from '../styles';

export const getButtonStyle = (type: string) => {
  let style = {
    svgFill: COLORS.primary_500,
    hoverBgColor: COLORS.primary_200,
    hoverSvgFill: COLORS.primary_700,
    activeBgColor: COLORS.primary_300,
    activeSvgFill: COLORS.primary_800,
    focusBgColor: COLORS.primary_200,
    focusSvgFill: COLORS.primary_700
  };

  switch(type)
  {
    case 'warning':
      style = {
        svgFill: COLORS.warning_500,
        hoverBgColor: COLORS.warning_200,
        hoverSvgFill: COLORS.warning_700,
        activeBgColor: COLORS.warning_300,
        activeSvgFill: COLORS.warning_800,
        focusBgColor: COLORS.warning_200,
        focusSvgFill: COLORS.warning_700
      };
      break;
    
    case 'critical':
      style = {
        svgFill: COLORS.critical_600,
        hoverBgColor: COLORS.critical_200,
        hoverSvgFill: COLORS.critical_700,
        activeBgColor: COLORS.critical_300,
        activeSvgFill: COLORS.critical_800,
        focusBgColor: COLORS.critical_200,
        focusSvgFill: COLORS.critical_700
      };
      break;

    case 'positive':
      style = {
        svgFill: COLORS.correct_500,
        hoverBgColor: COLORS.correct_200,
        hoverSvgFill: COLORS.correct_700,
        activeBgColor: COLORS.correct_300,
        activeSvgFill: COLORS.correct_800,
        focusBgColor: COLORS.correct_200,
        focusSvgFill: COLORS.correct_700
      };
      break;
  }

  return css`
    ${StyledSecondaryIconButton} {
    div {
      background-color: transparent;
    }
    div svg path,
    div svg {
      fill: ${style.svgFill};
    }
    &:hover:not(:disabled) {
      div {
        background-color: ${style.hoverBgColor};
      }
      div svg path,
      div svg {
        fill: ${style.hoverSvgFill};
      }
    }
    &:active:not(:disabled) {
      div {
        background: ${style.activeBgColor};
      }
      div svg path,
      div svg {
        fill: ${style.activeSvgFill};
      }
    }
  }`;
};
